import { useState, useEffect, useCallback } from 'react';
import Cookies from 'js-cookie';
import { HIDE_SEAWARE_MESSAGE_COOKIE_NAME } from './constants';

const useSeawareMessageHidden = () => {
  const [isHidden, setIsHidden] = useState<boolean>(false);

  useEffect(() => {
    const hasHiddenMessage: string = Cookies.get(
      HIDE_SEAWARE_MESSAGE_COOKIE_NAME
    );

    if (hasHiddenMessage !== undefined) {
      setIsHidden(hasHiddenMessage === 'true');
    }
  }, []);

  const handleCookieChange = useCallback((newValue: string) => {
    Cookies.set(HIDE_SEAWARE_MESSAGE_COOKIE_NAME, newValue, {
      expires: 365,
    });
    setIsHidden(newValue === 'true');
  }, []);

  return { isSeawareMessageHidden: isHidden, handleCookieChange };
};

export default useSeawareMessageHidden;
